import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useStore } from "@/context/Store";
import { eur, imgUrl, optionsLabel, priceLabel } from "@/lib/api";

export default function CartDrawer() {
  const { cartOpen, setCartOpen, lines, subtotal, hasQuote, updateQty, removeItem } = useStore();
  const nav = useNavigate();
  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent className="flex w-full flex-col bg-[var(--paper)] sm:max-w-md" data-testid="cart-drawer">
        <SheetHeader><SheetTitle className="font-display text-3xl">O teu carrinho</SheetTitle></SheetHeader>
        {lines.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center" data-testid="cart-empty">
            <ShoppingBag className="h-10 w-10 text-[var(--violet)]" />
            <p className="text-sm text-[var(--muted-ink)]">Ainda não tens produtos no carrinho.</p>
            <button className="btn-ghost" onClick={() => { setCartOpen(false); nav("/c/casa"); }}>Explorar a loja</button>
          </div>
        ) : (
          <>
            <ul className="-mx-2 mt-4 flex-1 space-y-4 overflow-y-auto px-2">
              {lines.map((l) => (
                <li key={l.key} className="flex gap-4 rounded-2xl border border-[var(--line)] bg-white p-3" data-testid={`cart-item-${l.product.slug}`}>
                  <img src={imgUrl(l.product.images?.[0])} alt="" className="h-20 w-20 rounded-xl object-cover" />
                  <div className="flex min-w-0 flex-1 flex-col">
                    <Link to={`/p/${l.product.slug}`} onClick={() => setCartOpen(false)} className="truncate text-sm font-semibold">{l.product.name}</Link>
                    <span className="text-xs font-bold text-[var(--violet)]">{priceLabel(l.product)}</span>
                    {optionsLabel(l.options) && <span className="truncate text-xs font-medium" data-testid={`cart-item-options-${l.product.slug}`}>{optionsLabel(l.options)}</span>}
                    {l.notes && <span className="truncate text-xs text-[var(--muted-ink)]">{l.notes}</span>}
                    <div className="mt-auto flex items-center gap-2 pt-2">
                      <button data-testid={`cart-item-decrease-${l.product.slug}`} onClick={() => updateQty(l.key, l.qty - 1)} className="rounded-full border border-[var(--line)] p-1"><Minus className="h-3 w-3" /></button>
                      <span className="w-6 text-center text-sm" data-testid={`cart-item-qty-${l.product.slug}`}>{l.qty}</span>
                      <button data-testid={`cart-item-increase-${l.product.slug}`} onClick={() => updateQty(l.key, l.qty + 1)} className="rounded-full border border-[var(--line)] p-1"><Plus className="h-3 w-3" /></button>
                      <button data-testid={`cart-item-remove-${l.product.slug}`} onClick={() => removeItem(l.key)} className="ml-auto p-1 text-[var(--muted-ink)] hover:text-red-500" aria-label="Remover"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <div className="space-y-3 border-t border-[var(--line)] pt-4">
              <div className="flex justify-between text-sm"><span>Subtotal{hasQuote ? " (estimado)" : ""}</span><b data-testid="cart-subtotal">{eur(subtotal)}</b></div>
              <p className="text-xs text-[var(--muted-ink)]">IVA incluído. Portes calculados no passo seguinte.{hasQuote && " Alguns produtos são sob orçamento: o valor final é confirmado por WhatsApp."}</p>
              <button data-testid="cart-checkout-button" className="btn-primary w-full" onClick={() => { setCartOpen(false); nav("/checkout"); }}>Finalizar pedido</button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
